import { render, staticRenderFns } from "./ButtonModelStock.vue?vue&type=template&id=0bb60d32&scoped=true"
import script from "./ButtonModelStock.vue?vue&type=script&lang=js"
export * from "./ButtonModelStock.vue?vue&type=script&lang=js"
import style0 from "./ButtonModelStock.vue?vue&type=style&index=0&id=0bb60d32&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bb60d32",
  null
  
)

export default component.exports